/* SilverShine — Motion que susurra (capa 10K, 18-jul-2026).
   Reveals sutiles al entrar en viewport: section-heads + tarjetas con
   stagger de 70ms. Una sola vez. Al terminar la transición se limpia la
   clase para devolverle a cada tarjeta su transition de hover (sleek lift).
   Sin IntersectionObserver o con reduced-motion: no hace nada (todo visible). */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Video ambiental del hero: fade-in al reproducir; se apaga con
     reduced-motion o ahorro de datos (el CSS oculta, esto además pausa). */
  var heroVideo = document.querySelector('[data-ss-hero-video]');
  if (heroVideo) {
    var conn = navigator.connection || {};
    if (reduce || conn.saveData) {
      heroVideo.removeAttribute('autoplay');
      heroVideo.pause();
    } else {
      heroVideo.addEventListener('playing', function () {
        heroVideo.classList.add('is-playing');
      });
      if (!heroVideo.paused && heroVideo.currentTime > 0) heroVideo.classList.add('is-playing');
    }
  }

  if (reduce) return;
  if (!('IntersectionObserver' in window)) return;

  var HEADS = '.ss-section-head';
  var GROUPS = [
    '.ss-categorias__card',
    '.ss-bestsellers__card',
    '.ss-materiales__card',
    '.ss-testimonios__card',
    '.ss-col-card',
    '.ss-relacionados__card',
    '.ss-blog__card'
  ];

  var targets = [];

  document.querySelectorAll(HEADS).forEach(function (el) {
    el.classList.add('ss-reveal');
    targets.push(el);
  });

  GROUPS.forEach(function (sel) {
    document.querySelectorAll(sel).forEach(function (el, i) {
      el.classList.add('ss-reveal');
      el.style.transitionDelay = Math.min(i, 5) * 70 + 'ms';
      targets.push(el);
    });
  });

  if (!targets.length) return;

  function settle(el) {
    el.style.transitionDelay = '';
    el.classList.remove('ss-reveal', 'is-in');
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        io.unobserve(el);
        el.classList.add('is-in');
        var done = false;
        el.addEventListener('transitionend', function onEnd(e) {
          if (e.target !== el || done) return;
          done = true;
          el.removeEventListener('transitionend', onEnd);
          settle(el);
        });
        /* Respaldo por si transitionend no dispara (elemento oculto, etc.) */
        setTimeout(function () {
          if (!done) { done = true; settle(el); }
        }, 1200);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  targets.forEach(function (el) { io.observe(el); });
})();
